import { ShieldCheck, TrendingUp, Trophy } from "lucide-react";
import { Eyebrow, Reveal, SectionShell } from "./Shared";

const CARDS = [
  {
    icon: Trophy,
    num: "01",
    title: "Professional Athletes",
    desc: "Established competitors seeking strategic management, sponsorship development and brand expansion on the biggest stages.",
  },
  {
    icon: TrendingUp,
    num: "02",
    title: "Emerging & Amateur Athletes",
    desc: "High-potential players building competitive résumés, visibility and a pipeline of professional opportunities.",
  },
  {
    icon: ShieldCheck,
    num: "03",
    title: "Youth & NIL Talent",
    desc: "Young athletes and families seeking responsible guidance, brand development and qualified NIL opportunities.",
    note: "Parent or legal guardian required for all youth inquiries.",
  },
];

export default function Roster() {
  return (
    <SectionShell id="roster">
      <Reveal>
        <Eyebrow className="mb-5">— Who We Represent</Eyebrow>
        <h2 className="max-w-3xl font-display text-4xl uppercase leading-[1.05] sm:text-5xl lg:text-6xl">
          Built for the <span className="text-volt">fastest-growing court</span>{" "}
          in sports.
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
          Pickleball first — with the infrastructure to represent athletes across
          emerging and established sports.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {CARDS.map((c, i) => (
          <Reveal key={c.num} delay={0.1 + i * 0.1} className="h-full">
            <div
              className="group flex h-full flex-col rounded-3xl border border-white/10 bg-surface p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-volt/50 hover:shadow-[0_20px_60px_rgba(132,204,22,0.1)]"
              data-testid={`roster-card-${c.num}`}
            >
              <div className="flex items-start justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-volt/10 text-volt transition-colors group-hover:bg-volt group-hover:text-ink">
                  <c.icon className="h-6 w-6" />
                </span>
                <span className="font-mono text-xs text-slate-600">{c.num}</span>
              </div>
              <h3 className="mt-6 font-display text-2xl uppercase text-white">
                {c.title}
              </h3>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-400">
                {c.desc}
              </p>
              {c.note && (
                <p className="mt-6 rounded-xl border border-volt/25 bg-volt/5 px-4 py-3 text-xs leading-relaxed text-volt">
                  {c.note}
                </p>
              )}
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-12 flex justify-center">
          <a
            href="#gallery"
            data-testid="who-we-represent-players-link"
            className="group inline-flex items-center gap-3 rounded-full border border-volt/50 px-8 py-4 font-display text-base uppercase tracking-wider text-volt transition-all hover:bg-volt hover:text-ink"
          >
            Meet Our Signed Players
            <span className="transition-transform group-hover:translate-y-0.5">↓</span>
          </a>
        </div>
      </Reveal>
    </SectionShell>
  );
}
